import { render } from "./GestãoDeEntregas.vue?vue&type=template&id=65c1a35d&scoped=true"
import script from "./GestãoDeEntregas.vue?vue&type=script&lang=js"
export * from "./GestãoDeEntregas.vue?vue&type=script&lang=js"

import "./GestãoDeEntregas.vue?vue&type=style&index=0&id=65c1a35d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65c1a35d"]])

export default __exports__